module.exports = __webpack_public_path__ + "static/media/22-iveco-mercedes.395b26ea.jpg";